import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface LablifeState {
  data?: any;
  setData(data: any): void;
}

export const useLablifeStore = create<LablifeState>()(
  devtools(
    immer((set) => ({
      setData: async (data: any) => {
        set({
          data,
        });
      },
    })),
  ),
);
